import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useCalendarLocaleConfig = () => {
  const { t } = useTranslation(i18nNS.calendar);

  return {
    monthNames: [
      t('monthNames.January'),
      t('monthNames.February'),
      t('monthNames.March'),
      t('monthNames.April'),
      t('monthNames.May'),
      t('monthNames.June'),
      t('monthNames.July'),
      t('monthNames.August'),
      t('monthNames.September'),
      t('monthNames.October'),
      t('monthNames.November'),
      t('monthNames.December'),
    ],
    monthNamesShort: [
      t('monthNamesShort.Jan'),
      t('monthNamesShort.Feb'),
      t('monthNamesShort.Mar'),
      t('monthNamesShort.Apr'),
      t('monthNamesShort.May'),
      t('monthNamesShort.Jun'),
      t('monthNamesShort.Jul'),
      t('monthNamesShort.Aug'),
      t('monthNamesShort.Sep'),
      t('monthNamesShort.Oct'),
      t('monthNamesShort.Nov'),
      t('monthNamesShort.Dec'),
    ],
    dayNames: [
      t('dayNames.Sunday'),
      t('dayNames.Monday'),
      t('dayNames.Tuesday'),
      t('dayNames.Wednesday'),
      t('dayNames.Thursday'),
      t('dayNames.Friday'),
      t('dayNames.Saturday'),
    ],
    dayNamesShort: [
      t('dayNamesShort.Sun'),
      t('dayNamesShort.Mon'),
      t('dayNamesShort.Tue'),
      t('dayNamesShort.Wed'),
      t('dayNamesShort.Thu'),
      t('dayNamesShort.Fri'),
      t('dayNamesShort.Sat'),
    ],
    today: t('today.Today'),
  };
};

export default useCalendarLocaleConfig;
